import {
  FarmOutbuildingsCard,
  IdBadge,
  ImageCheckboxes,
  MultiInputBoxCard,
  TakePictureCard,
  TextAreaCard,
  TitleCard,
  YesNoCard,
  YesNoEditCard,
} from '../../components/SelfInspect';
import ImageRadios from '../../components/SelfInspect/ImageRadios';

export const getComponentToRender = type => {
  switch (type) {
    case 'yesno':
      return YesNoCard;
    case 'yesno-edit':
      return YesNoEditCard;
    case 'textarea':
      return TextAreaCard;
    case 'multi-input':
      return MultiInputBoxCard;
    case 'image-checkboxes':
      return ImageCheckboxes;
    case 'image-radios':
      return ImageRadios;
    case 'take-picture':
      return TakePictureCard;
    case 'farm-structures':
      return FarmOutbuildingsCard;
    case 'title':
      return TitleCard;
    case 'idbadge':
      return IdBadge;
    default:
      return undefined;
  }
};

export const getFormAnswer = ({
  questionId,
  orderFormHeaderId,
  outbuildingNumber,
  quickVueInfo = {},
  formAnswers: formAnswersOverride,
}) => {
  const { formAnswers: primaryFormAnswers, outbuildings } = quickVueInfo;

  const formAnswers = formAnswersOverride
    ? formAnswersOverride
    : orderFormHeaderId
    ? outbuildings.find(ob => ob.orderFormHeaderId == orderFormHeaderId)?.formAnswers
    : primaryFormAnswers;

  return formAnswers?.find(fa => fa.questionId === questionId);
};

export const filterFormAnswers = ({
  questionId,
  questionIds,
  orderFormHeaderId,
  outbuildingNumber,
  quickVueInfo,
  requireImages = false,
}) => {
  const { formAnswers: primaryFormAnswers, outbuildings } = quickVueInfo;

  const formAnswers = orderFormHeaderId
    ? outbuildings.find(ob => ob.orderFormHeaderId == orderFormHeaderId)?.formAnswers
    : primaryFormAnswers;

  return formAnswers?.filter(
    fa =>
      (!!questionIds ? questionIds.includes(fa.questionId) : fa.questionId === questionId) &&
      (!requireImages || fa.formImages.length > 0),
  );
};
